<template>
  <template v-if="loginData.username === null"> HI, xxxx </template>
  <template v-else> 您好！{{ loginData.username }} </template>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";
export default {
  setup() {
    const store = useStore();

    const loginData = computed(() => store.getters["getLogin/get_loginData"]);

    return {
      loginData,
    };
  },
};
</script>

<style></style>
